/** Ce qu'un champ de fichier accepte : des extensions, et un poids maximal s'il est connu. */
export type FileRule = {
  /** Avec leur point, en minuscules : `['.zip']`. */
  extensions: readonly string[]
  /** `null` ou absent : pas de borne côté navigateur, l'API reste seule juge. */
  maxBytes?: number | null
}

export type FileRejection
  = | { kind: 'count' }
    | { kind: 'type', extensions: readonly string[] }
    | { kind: 'size', sizeBytes: number, maxBytes: number }

/**
 * Pourquoi des fichiers déposés ou choisis sont refusés, ou `null` s'ils
 * passent (#310). Un seul fichier à la fois. Le contrôle porte sur
 * l'extension et non sur le type MIME : un zip glissé depuis Windows arrive
 * souvent en `application/x-zip-compressed`, ou sans type du tout.
 */
export function checkFiles(files: readonly File[], rule: FileRule): FileRejection | null {
  if (files.length !== 1) return { kind: 'count' }
  const [file] = files
  const name = file.name.toLowerCase()
  if (!rule.extensions.some(extension => name.endsWith(extension))) {
    return { kind: 'type', extensions: rule.extensions }
  }
  if (rule.maxBytes != null && file.size > rule.maxBytes) {
    return { kind: 'size', sizeBytes: file.size, maxBytes: rule.maxBytes }
  }
  return null
}
